import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthToken } from '@store/auth'
import { selectPCRMetricsLink } from '@store/postCampaignReport'
import {
  fetchPcrMetrics,
  fetchPcrMetricsError,
  fetchPcrMetricsSuccess,
} from '@store/postCampaignReport/metrics/action'
import { IPCRMetricsResponse, PCRMetricsActionTypes } from '@store/postCampaignReport/metrics/types'
import networkRequest from '@utils/networkRequest'
import { WatcherFunction } from '..'

export function* handleFetchMetrics(action: ReturnType<typeof fetchPcrMetrics>) {
  const { campaignId, pcrChannel } = action.payload

  try {
    const link = yield select(selectPCRMetricsLink, campaignId, pcrChannel)
    const authToken: string = yield select(selectAuthToken)

    const metrics: IPCRMetricsResponse = yield call(
      networkRequest,
      link.method,
      link.href,
      undefined,
      authToken,
    )
    yield put(fetchPcrMetricsSuccess(metrics, campaignId, pcrChannel))
  } catch (error) {
    yield put(fetchPcrMetricsError(error, campaignId, pcrChannel))
  }
}

function* watchFetchMetrics() {
  yield takeLatest(PCRMetricsActionTypes.FETCH_REQUEST, handleFetchMetrics)
}

export const pcrMetricsSagas: ReadonlyArray<WatcherFunction> = [watchFetchMetrics]
